import axios from "axios";
import { getUserData, configFetch } from "./config"; // Mengimpor getUserData dan configFetch dari config.js

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

export const resyncRoomInvoice = async (RoomHistoryId) => {
  const user = getUserData();
  const response = await axios({ ...configFetch(`${HOSTNAME}/roomhistory/resync-invoice`, 'post', { RoomHistoryId }, true, { Authorization: `Bearer ${user.token}` }), timeout: 70000 });
  return response.data;
};

const API_SERVICES = {
  RoomHistorySearch: `${HOSTNAME}/roomhistory/search`, // Endpoint pencarian
  RoomHistoryRsv: `${HOSTNAME}/roomhistory/rsv`, // Endpoint pencarian
  RoomHistoryRsvUpdate: `${HOSTNAME}/roomhistory/rsvupdate`, // Endpoint pencarian
  RoomHistoryBillCheck: `${HOSTNAME}/roomhistory/billcheck`, // Endpoint pencarian
  RoomHistoryCheckIn: `${HOSTNAME}/roomhistory/checkin`, // Endpoint pencarian
  RoomHistoryCheckOut: `${HOSTNAME}/roomhistory/checkout`, // Endpoint pencarian
  RoomHistoryVD: `${HOSTNAME}/roomhistory/vd`, // Endpoint pencarian
  RoomHistoryOO: `${HOSTNAME}/roomhistory/oo`, // Endpoint pencarian
  RoomHistoryHU: `${HOSTNAME}/roomhistory/hu`, // Endpoint pencarian
  ListCheck: `${HOSTNAME}/roomhistory/listcheck`, // Endpoint pencarian
  InvoicePdf: `${HOSTNAME}/roomhistory/invoicepdf`, // Endpoint pencarian
  ReservasiUpdate: `${HOSTNAME}/roomhistory/rsvupdate`, // Endpoint pencarian
  ReservasiDelete: `${HOSTNAME}/roomhistory/deletersv`, // Endpoint pencarian
  CheckinConfirmasi: `${HOSTNAME}/roomhistory/checkin_confirmasi`, // Endpoint pencarian
  CheckoutConfirmasi: `${HOSTNAME}/roomhistory/checkout_confirmasi`, // Endpoint pencarian
  ArrivalList: `${HOSTNAME}/roomhistory/arrivalslist`, // Endpoint pencarian
  DepatureList: `${HOSTNAME}/roomhistory/depatureslist`, // Endpoint pencarian
  addRoomHistoryCheckin: `${HOSTNAME}/roomhistory/postcheckin`, // Endpoint pencarian
  RoomHistoryVDCreate: `${HOSTNAME}/roomhistory/vdcreate`, // Endpoint untuk membuat data VD
  UpdateImageDeposit: `${HOSTNAME}/roomhistory/updateimagedeposit`, // Endpoint untuk memperbarui gambar deposit
  DailyGuest: `${HOSTNAME}/roomhistory/dailyguest`, // Endpoint untuk memperbarui gambar deposit
  CashCollect: `${HOSTNAME}/roomhistory/cashcollect`, // Endpoint untuk memperbarui gambar deposit
  RemainingPayment: `${HOSTNAME}/roomhistory/remainingpayment`,
  CancelReservasi: `${HOSTNAME}/roomhistory/cancelrsv`,
  putUpdateVc: `${HOSTNAME}/roomhistory/vcupdate`,
  putUpdateHu: `${HOSTNAME}/roomhistory/updatehu`,
  putUpdateOo: `${HOSTNAME}/roomhistory/updateoo`,
  postListCancel: `${HOSTNAME}/roomhistory/listcancel`,
  postForecast: `${HOSTNAME}/roomhistory/forecast`,
};

export const fetchRoomHistoryById = async (id) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data

    const url = `${API_SERVICES.RoomHistoryBillCheck}`;
    // Prepare payload
    const payload = {
      RoomHistoryId: id,
    };

    const response = await axios(
      configFetch(url, "post", payload, true, {
        Authorization: `Bearer ${userData.token}`,
        "Content-Type": "application/json",
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Room History By Id:", error.message);
    throw error;
  }
};

// Function to search room history
export const searchRoomHistory = async (startDate, endDate) => {
  try {
    const userData = getUserData(); // Ensure token is valid and get user data

    // Prepare payload
    const payload = {
      room_start: startDate,
      room_end: endDate,
    };

    // Perform POST request
    const response = await axios(
      configFetch(API_SERVICES.RoomHistorySearch, "post", payload, true, {
        Authorization: `Bearer ${userData.token}`,
        "Content-Type": "application/json",
      })
    );

    return response.data;
  } catch (error) {
    console.error("Error searching room history:", error.message);
    throw error;
  }
};

// Function to add a new customer
export const addRoomHistoryRsv = async (roomHistoryRSV) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryRsv;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", roomHistoryRSV, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error adding customer:", error.message);
    throw error;
  }
};

export const UpdateRSV = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryRsvUpdate;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckIn:", error.message);
    throw error;
  }
};

export const CheckIn = async (roomHistoryCheckIn) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryCheckIn;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", roomHistoryCheckIn, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckIn:", error.message);
    throw error;
  }
};

export const cancelOo = async (id, RoomProductId) => {
  const userData = getUserData();
  const response = await axios(configFetch(`${HOSTNAME}/roomhistory/canceloo`, "put", { id, RoomProductId }, true, {
    Authorization: `Bearer ${userData.token}`,
    "Content-Type": "application/json",
  }));
  return response.data;
};

export const completeOo = async (id, RoomProductId) => {
  const userData = getUserData();
  const response = await axios(configFetch(`${HOSTNAME}/roomhistory/completeoo`, "put", { id, RoomProductId }, true, {
    Authorization: `Bearer ${userData.token}`,
    "Content-Type": "application/json",
  }));
  return response.data;
};

export const CheckOut = async (roomHistoryCheckOut) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryCheckOut;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", roomHistoryCheckOut, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckOut:", error.message);
    throw error;
  }
};

export const VD = async (vd) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryVD;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", vd, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckOut:", error.message);
    throw error;
  }
};

export const OO = async (oo) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryOO;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", oo, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckOut:", error.message);
    throw error;
  }
};

export const HU = async (hu) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryHU;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", hu, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error CheckOut:", error.message);
    throw error;
  }
};

export const ListCheck = async (listcheck) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.ListCheck;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", listcheck, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const InvoicePdf = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.InvoicePdf;

    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };

    // Make the POST request with responseType set to 'blob'
    const response = await axios.post(url, data, {
      headers: extraHeaders,
      responseType: "blob", // Important for handling PDF response
    });

    return response; // Return the entire response for further processing
  } catch (error) {
    console.error("Error generating PDF:", error.message);
    throw error; // Re-throw the error for handling in the calling function
  }
};

export const ReservasiUpdate = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.ReservasiUpdate;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Reservasi Update:", error.message);
    throw error;
  }
};

export const ReservasiDelete = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.ReservasiDelete;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "delete", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Reservasi Update:", error.message);
    throw error;
  }
};

export const CheckinConfirmasi = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.CheckinConfirmasi;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const CheckoutConfirmasi = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.CheckoutConfirmasi;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const ArrivalList = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.ArrivalList;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const DepatureList = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.DepatureList;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const PostCheckin = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.addRoomHistoryCheckin;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Lischeck:", error.message);
    throw error;
  }
};

export const createVD = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RoomHistoryVDCreate;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error creating VD:", error.message);
    throw error;
  }
};

export const updateImageDeposit = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.UpdateImageDeposit;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error updating image deposit:", error.message);
    throw error;
  }
};

export const fetchDaiyGuest = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.DailyGuest;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Daily Guest:", error.message);
    throw error;
  }
};

export const fetchCashCollect = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.CashCollect;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const fetchRemainingPayment = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.RemainingPayment;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const putCancelReservasi = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.CancelReservasi;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const putUpdateVc = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.putUpdateVc;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const putUpdateHu = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.putUpdateHu;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const putUpdateOo = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.putUpdateOo;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "put", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const postListCancel = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.postListCancel;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};

export const postForecast = async (data) => {
  try {
    const userData = getUserData();
    const url = API_SERVICES.postForecast;
    const extraHeaders = {
      Authorization: `Bearer ${userData.token}`,
      "Content-Type": "application/json", // Specify the content type
    };
    const response = await axios(
      configFetch(url, "post", data, true, extraHeaders)
    );
    return response.data;
  } catch (error) {
    console.error("Error Fecth Cash Collect:", error.message);
    throw error;
  }
};
